module.exports = __webpack_public_path__ + "img/Wojtek.7de7707f.jpg";